import { getEventIdFromLocation, getEventPageUrl } from '@component/PageReport/use-upload-file';
import { post } from '@lib/http';

export interface Coordinate {
  /**
   * 举报证据
   */
  accuse_evidence: AccuseEvidence;
  /**
   * 活动id
   */
  event_id: string;
  /**
   * 活动详情页url
   */
  event_url: string;
  /**
   * 操作类型：0-点击举报按钮，1-提交举报信息
   */
  operate_type: string;
}

/**
 * 举报证据
 */
export interface AccuseEvidence {
  /**
   * 有效证件图片-侵权特有
   */
  credential_image?: CredentialImage[];
  /**
   * 详情描述证据
   */
  description_evidence?: string;
  /**
   * 活动结束时间-侵权特有
   */
  end_time?: number;
  /**
   * 活动首页快照
   */
  registration_page?: ImageEvidence[];
  /**
   * 图片证据
   */
  image_evidence?: ImageEvidence[];
  /**
   * 一级违规描述
   */
  primary_violation_desc?: string;
  /**
   * 一级违规类型
   */
  primary_violation_type?: string;
  /**
   * 权利证据图片-侵权特有
   */
  right_image?: RightImage[];
  /**
   * 二级违规描述
   */
  secondary_violation_desc?: string;
  /**
   * 二级违规类型
   */
  secondary_violation_type?: string;
  /**
   * 活动开始时间-侵权特有
   */
  start_time?: number;
}

/**
 * 有效证件图片-侵权特有
 */
export interface CredentialImage {
  /**
   * 有效证件图片的cos_id
   */
  cos_id?: string;
  /**
   * 有效证件图片的cos_url
   */
  cos_url?: string;
}

/**
 * 图片证据
 */
export interface ImageEvidence {
  /**
   * 图片证据的cos_id
   */
  cos_id?: string;
  /**
   * 图片证据的cos_url
   */
  cos_url?: string;
}

/**
 * 权利证据图片-侵权特有
 */
export interface RightImage {
  /**
   * 权利证据图片cos_id
   */
  cos_id?: string;
  /**
   * 权利证据图片cos_url
   */
  cos_url?: string;
}

export const DEFAULT_DATA: Coordinate = {
  operate_type: '0',
  event_id: getEventIdFromLocation(),
  event_url: getEventPageUrl(),
  accuse_evidence: {},
};

/**
 * 举报
 */
export async function fetchReport(params: Coordinate) {
  const resp = await post('/wemeet-tapi', '/v2/activities/register/accuse-event', params);
  return resp as any;
}
